var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKiwi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 511.996 511.996",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#966645"
    },
    cx: 255.998,
    cy: 255.998,
    r: 255.998
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BBE383"
    },
    cx: 255.998,
    cy: 255.998,
    r: 238.638
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FFFCB5"
    },
    cx: 255.998,
    cy: 255.998,
    rx: 82.528,
    ry: 91.958
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FFFCB5"
    },
    cx: 255.998,
    cy: 255.998,
    rx: 91.958,
    ry: 82.525
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93BF54"
    },
    d: "M258.811,154.694c-0.026,1.811-1.518,3.255-3.325,3.23l0,0c-1.811-0.029-3.259-1.518-3.234-3.329 l0.933-62.041c0.026-1.811,1.522-3.259,3.332-3.23l0,0c1.807,0.029,3.255,1.518,3.226,3.329L258.811,154.694z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93BF54"
    },
    d: "M258.811,422.346c-0.026,1.814-1.518,3.259-3.325,3.237l0,0c-1.811-0.029-3.259-1.522-3.234-3.329 l0.933-62.048c0.026-1.807,1.522-3.252,3.332-3.23l0,0c1.807,0.029,3.255,1.522,3.226,3.329L258.811,422.346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93BF54"
    },
    d: "M272.835,164.706c-0.274,1.639-1.942,2.718-3.727,2.421l0,0c-1.785-0.3-3.018-1.869-2.743-3.508 l9.408-56.111c0.274-1.639,1.95-2.725,3.735-2.425l0,0c1.781,0.304,3.007,1.876,2.732,3.512L272.835,164.706z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93BF54"
    },
    d: "M236.224,407.393c-0.274,1.635-1.946,2.721-3.727,2.422l0,0c-1.785-0.3-3.014-1.873-2.74-3.508 l9.408-56.111c0.274-1.635,1.946-2.721,3.735-2.422l0,0c1.781,0.3,3.01,1.873,2.736,3.508L236.224,407.393z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93BF54"
    },
    d: "M287.083,159.468c-0.527,1.737-2.359,2.707-4.089,2.187l0,0c-1.73-0.527-2.714-2.359-2.187-4.089 l18.033-59.371c0.527-1.734,2.363-2.71,4.097-2.184l0,0c1.73,0.527,2.707,2.359,2.18,4.089L287.083,159.468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93BF54"
    },
    d: "M213.157,416.709c-0.527,1.737-2.356,2.707-4.086,2.187l0,0c-1.73-0.523-2.714-2.359-2.187-4.093 l18.033-59.367c0.527-1.737,2.359-2.707,4.097-2.187l0,0c1.73,0.53,2.707,2.363,2.18,4.093L213.157,416.709z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93BF54"
    },
    d: "M297.8,172.961c-0.717,1.5-2.619,2.078-4.25,1.299l0,0c-1.631-0.779-2.381-2.63-1.668-4.126 l24.54-51.331c0.717-1.5,2.626-2.078,4.261-1.295l0,0c1.628,0.783,2.374,2.63,1.657,4.126L297.8,172.961z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93BF54"
    },
    d: "M195.578,396.101c-0.717,1.5-2.619,2.078-4.254,1.299l0,0c-1.631-0.786-2.381-2.63-1.664-4.13 l24.54-51.331c0.717-1.5,2.623-2.078,4.258-1.295l0,0c1.631,0.779,2.374,2.623,1.661,4.122L195.578,396.101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93BF54"
    },
    d: "M315.994,173.978c-1.039,1.485-3.084,1.84-4.565,0.808l0,0c-1.481-1.039-1.844-3.087-0.808-4.569 l35.587-50.829c1.039-1.481,3.087-1.84,4.572-0.801l0,0c1.481,1.039,1.84,3.084,0.801,4.565L315.994,173.978z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93BF54"
    },
    d: "M165.788,395.512c-1.039,1.485-3.08,1.844-4.565,0.808l0,0c-1.481-1.035-1.844-3.087-0.808-4.565 l35.587-50.829c1.039-1.485,3.084-1.844,4.572-0.801l0,0c1.478,1.035,1.84,3.08,0.801,4.565L165.788,395.512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93BF54"
    },
    d: "M321.982,190.131c-1.145,1.203-3.135,1.16-4.444-0.084l0,0c-1.31-1.247-1.449-3.241-0.304-4.441 l39.274-41.165c1.145-1.2,3.142-1.16,4.455,0.091l0,0c1.306,1.251,1.438,3.237,0.293,4.437L321.982,190.131z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93BF54"
    },
    d: "M155.488,370.46c-1.145,1.207-3.135,1.156-4.448-0.084l0,0c-1.306-1.251-1.445-3.237-0.3-4.444 l39.278-41.165c1.145-1.2,3.135-1.156,4.448,0.091l0,0c1.306,1.251,1.441,3.237,0.296,4.437L155.488,370.46z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93BF54"
    },
    d: "M337.656,195.004c-1.423,1.123-3.486,0.867-4.602-0.549l0,0c-1.116-1.427-0.871-3.49,0.552-4.609 l48.821-38.301c1.427-1.119,3.49-0.867,4.605,0.56l0,0c1.116,1.423,0.867,3.486-0.56,4.602L337.656,195.004z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93BF54"
    },
    d: "M129.572,363.356c-1.427,1.123-3.482,0.863-4.602-0.549l0,0c-1.116-1.43-0.871-3.493,0.552-4.609 l48.818-38.301c1.427-1.123,3.486-0.871,4.609,0.556l0,0c1.116,1.423,0.863,3.486-0.56,4.602L129.572,363.356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93BF54"
    },
    d: "M338.695,212.206c-1.449,0.816-3.34,0.201-4.228-1.375l0,0c-0.893-1.577-0.446-3.519,0.999-4.338 l49.538-27.979c1.449-0.816,3.343-0.198,4.236,1.383l0,0c0.885,1.577,0.435,3.515-1.01,4.335L338.695,212.206z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93BF54"
    },
    d: "M126.993,336.387c-1.449,0.823-3.34,0.201-4.232-1.372l0,0c-0.889-1.58-0.443-3.522,1.006-4.338 l49.542-27.983c1.445-0.816,3.336-0.194,4.228,1.386l0,0c0.889,1.573,0.439,3.508-1.006,4.331L126.993,336.387z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93BF54"
    },
    d: "M353.348,224.427c-1.705,0.607-3.577-0.293-4.185-1.997l0,0c-0.604-1.708,0.293-3.581,2.001-4.188 l58.515-20.649c1.708-0.604,3.581,0.293,4.185,2.005l0,0c0.6,1.708-0.296,3.581-2.001,4.181L353.348,224.427z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93BF54"
    },
    d: "M102.325,317.307c-1.708,0.607-3.581-0.293-4.185-1.993l0,0c-0.604-1.708,0.293-3.585,2.001-4.188 l58.511-20.652c1.708-0.607,3.581,0.293,4.188,2.001l0,0c0.6,1.708-0.3,3.581-2.005,4.188L102.325,317.307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93BF54"
    },
    d: "M348.827,241.056c-1.631,0.311-3.226-0.878-3.566-2.656l0,0c-0.34-1.774,0.706-3.475,2.337-3.786 l55.892-10.648c1.631-0.311,3.23,0.882,3.57,2.667l0,0c0.337,1.774-0.713,3.471-2.345,3.782L348.827,241.056z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93BF54"
    },
    d: "M108.514,290.931c-1.635,0.315-3.226-0.878-3.57-2.652l0,0c-0.337-1.778,0.71-3.479,2.341-3.786 l55.896-10.652c1.628-0.307,3.223,0.882,3.563,2.667l0,0c0.337,1.778-0.71,3.471-2.337,3.779L108.514,290.931z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93BF54"
    },
    d: "M358.732,261.108c-1.811-0.04-3.241-1.547-3.204-3.351l0,0c0.044-1.811,1.547-3.252,3.354-3.208 l62.033,1.445c1.811,0.044,3.245,1.547,3.201,3.358l0,0c-0.044,1.807-1.547,3.245-3.354,3.201L358.732,261.108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93BF54"
    },
    d: "M91.084,258.902c-1.814-0.04-3.245-1.54-3.204-3.347l0,0c0.04-1.807,1.544-3.248,3.354-3.208 l62.03,1.445c1.814,0.044,3.245,1.547,3.204,3.358l0,0c-0.044,1.807-1.547,3.245-3.358,3.201L91.084,258.902z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93BF54"
    },
    d: "M348.604,275.048c-1.635-0.289-2.707-1.968-2.392-3.746l0,0c0.311-1.781,1.895-2.999,3.526-2.71 l56.035,9.873c1.635,0.285,2.707,1.972,2.392,3.749l0,0c-0.315,1.785-1.898,2.992-3.534,2.707L348.604,275.048z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93BF54"
    },
    d: "M106.228,236.443c-1.639-0.289-2.707-1.968-2.396-3.746l0,0c0.318-1.785,1.898-2.999,3.533-2.71 l56.038,9.869c1.631,0.289,2.699,1.968,2.385,3.753l0,0c-0.315,1.778-1.895,2.988-3.526,2.703L106.228,236.443z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93BF54"
    },
    d: "M352.371,293.224c-1.708-0.607-2.59-2.487-1.986-4.192l0,0c0.611-1.701,2.491-2.593,4.192-1.986 l58.434,20.875c1.705,0.607,2.593,2.487,1.983,4.192l0,0c-0.611,1.701-2.487,2.593-4.192,1.979L352.371,293.224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93BF54"
    },
    d: "M98.992,206.983c-1.712-0.607-2.597-2.487-1.99-4.188l0,0c0.607-1.705,2.487-2.597,4.192-1.99 l58.43,20.872c1.708,0.611,2.593,2.487,1.986,4.196l0,0c-0.611,1.701-2.491,2.59-4.192,1.983L98.992,206.983z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93BF54"
    },
    d: "M338.377,303.276c-1.459-0.794-1.95-2.721-1.094-4.309l0,0c0.856-1.595,2.743-2.257,4.203-1.47 l50.091,26.991c1.46,0.786,1.95,2.721,1.09,4.316l0,0c-0.86,1.595-2.743,2.242-4.203,1.456L338.377,303.276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93BF54"
    },
    d: "M120.427,190.42c-1.467-0.79-1.95-2.718-1.097-4.313l0,0c0.863-1.595,2.743-2.25,4.207-1.463 l50.091,26.991c1.456,0.786,1.942,2.714,1.086,4.313l0,0c-0.86,1.595-2.74,2.246-4.199,1.456L120.427,190.42z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93BF54"
    },
    d: "M332.301,326.342c-1.364-1.2-1.489-3.274-0.3-4.631l0,0c1.2-1.357,3.274-1.492,4.634-0.3 l46.564,41.015c1.357,1.2,1.489,3.274,0.289,4.631l0,0c-1.196,1.357-3.27,1.492-4.627,0.293L332.301,326.342z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93BF54"
    },
    d: "M128.807,152.47c-1.364-1.196-1.492-3.27-0.3-4.624l0,0c1.192-1.361,3.274-1.492,4.631-0.296 l46.564,41.012c1.361,1.196,1.492,3.27,0.293,4.631l0,0c-1.196,1.357-3.274,1.489-4.631,0.293L128.807,152.47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93BF54"
    },
    d: "M315.577,330.501c-1.068-1.273-0.808-3.252,0.578-4.408l0,0c1.386-1.163,3.38-1.079,4.448,0.194 l36.549,43.609c1.068,1.266,0.805,3.252-0.585,4.408l0,0c-1.386,1.163-3.38,1.072-4.444-0.201L315.577,330.501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93BF54"
    },
    d: "M154.851,145.015c-1.072-1.277-0.805-3.248,0.578-4.411l0,0c1.39-1.16,3.38-1.075,4.448,0.198 l36.549,43.609c1.064,1.269,0.801,3.245-0.589,4.408l0,0c-1.386,1.16-3.373,1.075-4.441-0.201L154.851,145.015z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93BF54"
    },
    d: "M303.426,348.655c-0.86-1.595-0.252-3.581,1.339-4.437l0,0c1.598-0.856,3.588-0.256,4.444,1.335 l29.303,54.696c0.852,1.595,0.249,3.585-1.346,4.444l0,0c-1.595,0.849-3.585,0.249-4.437-1.342L303.426,348.655z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93BF54"
    },
    d: "M173.499,114.652c-0.86-1.598-0.256-3.581,1.335-4.437l0,0c1.595-0.856,3.585-0.256,4.444,1.339 l29.299,54.692c0.856,1.598,0.256,3.581-1.342,4.444l0,0c-1.595,0.849-3.585,0.249-4.437-1.346L173.499,114.652z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93BF54"
    },
    d: "M286.303,346.713c-0.556-1.566,0.38-3.329,2.078-3.929l0,0c1.705-0.607,3.544,0.172,4.1,1.737 l19.013,53.624c0.556,1.566-0.38,3.329-2.089,3.929l0,0c-1.705,0.607-3.541-0.179-4.093-1.737L286.303,346.713z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93BF54"
    },
    d: "M200.505,116.762c-0.56-1.569,0.38-3.321,2.081-3.932l0,0c1.708-0.6,3.544,0.176,4.1,1.741 l19.013,53.631c0.552,1.558-0.384,3.314-2.092,3.921l0,0c-1.705,0.604-3.537-0.172-4.089-1.737L200.505,116.762z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93BF54"
    },
    d: "M269.967,359.292c-0.271-1.792,0.969-3.457,2.754-3.731l0,0c1.792-0.263,3.464,0.973,3.735,2.758 l9.189,61.368c0.267,1.785-0.973,3.457-2.762,3.731l0,0c-1.789,0.263-3.46-0.973-3.727-2.758L269.967,359.292z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93BF54"
    },
    d: "M226.366,95.214c-0.274-1.792,0.966-3.46,2.751-3.731l0,0c1.789-0.271,3.464,0.969,3.735,2.758 l9.185,61.364c0.271,1.789-0.966,3.457-2.758,3.731l0,0c-1.789,0.263-3.46-0.973-3.727-2.762L226.366,95.214z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.5591 -0.8291 0.8291 -0.5591 144.4985 433.1821)",
    style: {
      fill: "#4F1818"
    },
    cx: 187.428,
    cy: 178.17,
    rx: 6.156,
    ry: 3.607
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.5591 -0.8291 0.8291 -0.5591 180.2934 383.0544)",
    style: {
      fill: "#4F1818"
    },
    cx: 191.997,
    cy: 143.589,
    rx: 6.156,
    ry: 3.607
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.0411 -0.9992 0.9992 0.0411 79.0011 380.4405)",
    style: {
      fill: "#4F1818"
    },
    cx: 237.706,
    cy: 149.062,
    rx: 6.16,
    ry: 3.607
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.5923 -0.8057 0.8057 -0.5923 223.7195 423.5953)",
    style: {
      fill: "#4F1818"
    },
    cx: 219.03,
    cy: 155.196,
    rx: 6.156,
    ry: 3.607
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1689 -0.9856 0.9856 0.1689 84.8986 360.1225)",
    style: {
      fill: "#4F1818"
    },
    cx: 255.992,
    cy: 129.719,
    rx: 6.156,
    ry: 3.607
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1694 -0.9855 0.9855 0.1694 80.4542 391.3864)",
    style: {
      fill: "#4F1818"
    },
    cx: 272.429,
    cy: 147.961,
    rx: 6.156,
    ry: 3.606
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5438 -0.8392 0.8392 0.5438 4.3369 323.8169)",
    style: {
      fill: "#4F1818"
    },
    cx: 300.014,
    cy: 157.919,
    rx: 6.156,
    ry: 3.607
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1293 -0.9916 0.9916 0.1293 125.2629 402.1001)",
    style: {
      fill: "#4F1818"
    },
    cx: 291.599,
    cy: 129.722,
    rx: 6.156,
    ry: 3.607
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.622 -0.783 0.783 0.622 -9.6554 311.4041)",
    style: {
      fill: "#4F1818"
    },
    cx: 317.71,
    cy: 165.703,
    rx: 6.156,
    ry: 3.607
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.622 -0.783 0.783 0.622 -0.0218 329.8333)",
    style: {
      fill: "#4F1818"
    },
    cx: 341.614,
    cy: 164.939,
    rx: 6.156,
    ry: 3.607
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9651 -0.2617 0.2617 0.9651 -38.406 102.3105)",
    style: {
      fill: "#4F1818"
    },
    cx: 364.911,
    cy: 195.347,
    rx: 6.156,
    ry: 3.606
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5898 -0.8075 0.8075 0.5898 -5.4538 356.2478)",
    style: {
      fill: "#4F1818"
    },
    cx: 347.953,
    cy: 183.492,
    rx: 6.156,
    ry: 3.606
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9907 -0.136 0.136 0.9907 -26.083 51.2524)",
    style: {
      fill: "#4F1818"
    },
    cx: 362.06,
    cy: 216.52,
    rx: 6.156,
    ry: 3.607
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8338 0.5521 -0.5521 0.8338 227.0929 -141.7456)",
    style: {
      fill: "#4F1818"
    },
    cx: 348.953,
    cy: 306.275,
    rx: 6.156,
    ry: 3.607
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9907 -0.1357 0.1357 0.9907 -27.6743 53.8991)",
    style: {
      fill: "#4F1818"
    },
    cx: 381.499,
    cy: 229.934,
    rx: 6.156,
    ry: 3.606
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9642 0.2651 -0.2651 0.9642 85.4232 -85.353)",
    style: {
      fill: "#4F1818"
    },
    cx: 358.911,
    cy: 273.782,
    rx: 6.16,
    ry: 3.607
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9642 0.2651 -0.2651 0.9642 90.5669 -85.5031)",
    style: {
      fill: "#4F1818"
    },
    cx: 362.039,
    cy: 292.763,
    rx: 6.156,
    ry: 3.607
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9845 -0.1756 0.1756 0.9845 -39.4282 71.4991)",
    style: {
      fill: "#4F1818"
    },
    cx: 384.308,
    cy: 258.548,
    rx: 6.156,
    ry: 3.607
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.218 0.976 -0.976 0.218 568.5222 18.955)",
    style: {
      fill: "#4F1818"
    },
    cx: 272.433,
    cy: 364.236,
    rx: 6.156,
    ry: 3.607
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6242 0.7813 -0.7813 0.6242 389.8916 -144.5281)",
    style: {
      fill: "#4F1818"
    },
    cx: 345.174,
    cy: 333.005,
    rx: 6.16,
    ry: 3.607
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2189 0.9757 -0.9757 0.2189 596.858 -0.7698)",
    style: {
      fill: "#4F1818"
    },
    cx: 298.91,
    cy: 372.416,
    rx: 6.152,
    ry: 3.606
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5628 0.8266 -0.8266 0.5628 422.5121 -121.7752)",
    style: {
      fill: "#4F1818"
    },
    cx: 326.373,
    cy: 338.522,
    rx: 6.156,
    ry: 3.607
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2189 0.9757 -0.9757 0.2189 555.3574 34.7547)",
    style: {
      fill: "#4F1818"
    },
    cx: 255.971,
    cy: 364.248,
    rx: 6.153,
    ry: 3.607
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3783 0.9257 -0.9257 0.3783 521.833 -65.9189)",
    style: {
      fill: "#4F1818"
    },
    cx: 309.991,
    cy: 355.531,
    rx: 6.156,
    ry: 3.607
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.4022 0.9156 -0.9156 -0.4022 650.6758 303.2278)",
    style: {
      fill: "#4F1818"
    },
    cx: 226.341,
    cy: 364.044,
    rx: 6.156,
    ry: 3.607
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2575 0.9663 -0.9663 0.2575 525.309 32.7852)",
    style: {
      fill: "#4F1818"
    },
    cx: 241.322,
    cy: 358.205,
    rx: 6.16,
    ry: 3.607
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.5162 0.8565 -0.8565 -0.5162 619.6959 365.0609)",
    style: {
      fill: "#4F1818"
    },
    cx: 206.739,
    cy: 357.56,
    rx: 6.156,
    ry: 3.607
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.5164 0.8564 -0.8564 -0.5164 591.8726 368.1545)",
    style: {
      fill: "#4F1818"
    },
    cx: 191.98,
    cy: 351.205,
    rx: 6.156,
    ry: 3.603
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.8119 0.5839 -0.5839 -0.8119 492.1317 491.9566)",
    style: {
      fill: "#4F1818"
    },
    cx: 166.8,
    cy: 325.272,
    rx: 6.157,
    ry: 3.603
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.4815 0.8765 -0.8765 -0.4815 558.5571 360.6643)",
    style: {
      fill: "#4F1818"
    },
    cx: 172.592,
    cy: 345.556,
    rx: 6.153,
    ry: 3.607
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.8646 0.5024 -0.5024 -0.8646 463.6818 496.4051)",
    style: {
      fill: "#4F1818"
    },
    cx: 164.964,
    cy: 310.671,
    rx: 6.156,
    ry: 3.607
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.8646 0.5024 -0.5024 -0.8646 423.4034 480.2291)",
    style: {
      fill: "#4F1818"
    },
    cx: 147.004,
    cy: 297.157,
    rx: 6.152,
    ry: 3.607
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.9942 -0.1077 0.1077 -0.9942 246.4708 526.8178)",
    style: {
      fill: "#4F1818"
    },
    cx: 137.461,
    cy: 256.753,
    rx: 6.156,
    ry: 3.607
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.8438 0.5366 -0.5366 -0.8438 433.7359 430.6961)",
    style: {
      fill: "#4F1818"
    },
    cx: 154.194,
    cy: 278.464,
    rx: 6.156,
    ry: 3.607
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.9722 -0.2343 0.2343 -0.9722 226.3474 509.0941)",
    style: {
      fill: "#4F1818"
    },
    cx: 143.414,
    cy: 241.102,
    rx: 6.156,
    ry: 3.607
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.9721 -0.2346 0.2346 -0.9721 226.0544 463.8859)",
    style: {
      fill: "#4F1818"
    },
    cx: 140.619,
    cy: 218.497,
    rx: 6.156,
    ry: 3.607
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.8014 -0.5981 0.5981 -0.8014 197.9441 437.5711)",
    style: {
      fill: "#4F1818"
    },
    cx: 171.614,
    cy: 185.925,
    rx: 6.16,
    ry: 3.607
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.9808 -0.1949 0.1949 -0.9808 245.9092 419.0155)",
    style: {
      fill: "#4F1818"
    },
    cx: 143.569,
    cy: 197.41,
    rx: 6.156,
    ry: 3.607
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKiwi);
export default __webpack_public_path__ + "static/media/kiwi.53c221f3b4e45763bbeebd8203be4ef3.svg";
export { ForwardRef as ReactComponent };